import { Fragment } from "react";
import { Link } from "react-router-dom";

const NavbarDashboard = () => {
    return (
        <Fragment>
            <nav className="w-full">
                <div className="max-w-[1920px] px-5 tablet:px-8 desktop:px-[120px] pb-5 mx-auto w-full flex items-center justify-between">
                    <div className="w-full flex items-center justify-between">
                        <Link to="/">
                            <img src="/images/universal/anonymousproxies.svg" width="213px" height="40px" alt="logo" />
                        </Link>
                    </div>
                </div>
            </nav>
        </Fragment>
    );
};

export default NavbarDashboard;